import { v1ApiClient } from '@/services';
import type { FeedbackListItemWithBlock } from '@/types/feedback';

import type { HeySynclyChatRetrieveFeedbacksRequestParams } from '../model';

export const retrieveHeySynclyChatFeedbacks = async (
  params: HeySynclyChatRetrieveFeedbacksRequestParams,
  sortStatus?: SortStatusT,
): Promise<{
  feedbacks: FeedbackListItemWithBlock[];
}> => {
  if (params.isPublic) {
    const { chat_alias, message_id, citation_ids, report_alias } = params;
    const response = await v1ApiClient.post(
      `/hey-syncly/chats/${chat_alias}/feedbacks/${report_alias}/public`,
      {
        message_id,
        citation_ids,
      },
      {
        params: {
          sortby: sortStatus?.sortBy || 'date',
          order: sortStatus?.orderStatus || 'desc',
        },
      },
    );

    return response.data;
  }

  const { chat_alias, message_id, citation_ids } = params;
  const response = await v1ApiClient.post(
    `/hey-syncly/chats/${chat_alias}/feedbacks`,
    {
      message_id,
      citation_ids,
    },
    {
      params: {
        sortby: sortStatus?.sortBy || 'date',
        order: sortStatus?.orderStatus || 'desc',
      },
    },
  );

  return response.data;
};
